"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartTrialService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class StartTrialService {
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static startTrialCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/start_trial/',
        });
    }
}
exports.StartTrialService = StartTrialService;
